export default "__VITE_ASSET__DNK3jHoz__"